export const ADMIN_PERMISSION_IMPLICATIONS = {
  manage_users: [
    'manage_couriers',
    'manage_kyc',
    'manage_affiliates',
    'manage_ambassadors',
    'manage_super_ambassadors',
  ],
  manage_deliveries: ['manage_couriers'],
  manage_payments: [
    'manage_wallets',
    'manage_affiliates',
    'manage_ambassadors',
    'manage_super_ambassadors',
  ],
  view_stats: ['view_reports'],
  view_reports: ['view_stats'],
};

export const expandAdminPermissions = (rawPermissions = []) => {
  const expanded = new Set(
    (rawPermissions || [])
      .map((permission) => String(permission || '').trim())
      .filter(Boolean),
  );

  const queue = Array.from(expanded);
  while (queue.length > 0) {
    const current = queue.pop();
    const impliedPermissions = ADMIN_PERMISSION_IMPLICATIONS[current] || [];
    impliedPermissions.forEach((permission) => {
      if (!expanded.has(permission)) {
        expanded.add(permission);
        queue.push(permission);
      }
    });
  }

  return Array.from(expanded);
};

export const hasAdminPermission = (
  admin,
  requiredPermissions = [],
  { permissionsLoaded = true, allowLegacyWhenEmpty = false } = {},
) => {
  if (!requiredPermissions.length) {
    return true;
  }

  if (!permissionsLoaded) {
    return true;
  }

  if (!admin || admin.role !== 'admin') {
    return false;
  }

  if (admin.is_super_admin) {
    return true;
  }

  const expandedPermissions = expandAdminPermissions(admin.permissions || []);
  if (!expandedPermissions.length && allowLegacyWhenEmpty) {
    return true;
  }

  if (expandedPermissions.includes('*') || expandedPermissions.includes('admin:*')) {
    return true;
  }

  return requiredPermissions.some((permission) => expandedPermissions.includes(permission));
};

export const formatAdminScopeSummary = (admin) => {
  if (!admin) {
    return 'Global';
  }
  return String(admin.scope_summary || admin.scope_label || 'Global');
};

export const getAdminStatusMeta = (admin) => {
  if (admin?.is_active === false || admin?.status_code === 'suspended') {
    return {
      code: 'suspended',
      label: 'Suspendu',
      className: 'bg-red-100 text-red-700',
    };
  }
  return {
    code: 'active',
    label: 'Actif',
    className: 'bg-green-100 text-green-700',
  };
};
